import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const ConditionTextSkeleton: FC = () => {
  return <ThemedSkeleton colorVariant="secondary" variant="text" width={120} height={20} />;
};

